
/**
 * Options for charts
 * @author Prasanth Venkatesan
 */
export class Options {
    showLegend: boolean;

    constructor(showLegend = true) {
        this.showLegend = showLegend;
    }
}
